import type { TranslationKey } from "@connect/i18n";
import type { CardBrand, CardField, FieldFlags, FieldFlagsMap } from "./card-fields.types";

export const FIELD_NAMES = {
  number: "number",
  expiry: "expiryDate",
  cvc: "cvc",
} as const;

// VGS reports card types with its own short codes; normalise to our brand union.
const VGS_BRAND: Record<string, CardBrand> = {
  visa: "visa",
  mastercard: "mastercard",
  maestro: "maestro",
  amex: "american_express",
  american_express: "american_express",
  discover: "discover",
  dinersclub: "diners_club",
  diners_club: "diners_club",
};

export function vgsToBrand(cardType?: string): CardBrand {
  return (cardType && VGS_BRAND[cardType.toLowerCase()]) || "unknown";
}

export const EMPTY_FLAGS: FieldFlagsMap = {
  number: { valid: false, empty: true, dirty: false },
  expiry: { valid: false, empty: true, dirty: false },
  cvc: { valid: false, empty: true, dirty: false },
};

// Order also sets which message wins when several fields are invalid at once.
export const VALIDATION_ORDER: CardField[] = ["number", "expiry", "cvc"];

export const VALIDATION_COPY: Record<CardField, TranslationKey> = {
  number: "addCard.validation.cardNumber",
  expiry: "addCard.validation.expiry",
  cvc: "addCard.validation.cvc",
};

export function fieldFlags(state?: {
  isValid?: boolean;
  isEmpty?: boolean;
  isDirty?: boolean;
}): FieldFlags {
  return {
    valid: !!state?.isValid,
    empty: state?.isEmpty !== false,
    dirty: !!state?.isDirty,
  };
}
